import axios from 'axios';

export default async (id) => {
  const result = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/users/${id}`).catch(() => ({
    data: undefined,
  }));
  return result?.data;
};
